module.exports = __webpack_public_path__ + "static/media/mcpLogo.f052ad5c.svg";